import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'found';
import withAuth from '../App/Authenticate';
import {
  Accordion,
  Container,
  Grid,
  Icon,
  Item,
  Message,
  Segment
} from 'semantic-ui-react';
import MobileHeader from '../App/MobileHeader';
import {
  Analytics,
  AvailabilityChecker,
  GlobalNotifications,
  Intent
} from '../Modules';
import { FloatingLabelInput as Input } from '../Elements';
import Formsy from 'formsy-react';
import ClipboardButton from 'react-clipboard.js';
import styles from './Leads.scss';
import SMSNotifications from './SMSNotifications';
import RecaptchaSettings from './RecaptchaSettings';
import Script from 'react-load-script';

const EmbedComponent = class Embed extends React.Component {
  static propTypes = {
    toggleSidebar: PropTypes.func,
    sidebarOpen: PropTypes.bool,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.selectEmbedCode = this.selectEmbedCode.bind(this);
    this.onAccordionClick = this.onAccordionClick.bind(this);
    this.onSuccessfulCopy = this.onSuccessfulCopy.bind(this);
    this.getEmbedCode = this.getEmbedCode.bind(this);
    this.textFieldChange = this.textFieldChange.bind(this);
    this.state = {
      title: '',
      redirectURI: '',
      activeIndex: 0
    };
  }

  componentDidMount() {
    Analytics.trackEvent('viewed-lead-embed');
  }

  onAccordionClick(e, titleProps) {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  }

  onSuccessfulCopy() {
    GlobalNotifications.show({
      message: 'Successfully copied embed code',
      intent: Intent.SUCCESS
    });
  }

  getEmbedCode() {
    return `<form action="${process.env.BASE_URL}/embed_widgets/${this.props.viewer.embed_token}?${this.state.redirectURI !== '' ? `redirect_uri=${encodeURIComponent(this.state.redirectURI)}` : ''}" accept-charset="UTF-8" method="post">
<div>
  <label for="embed_widget_form_first_name"><abbr title="required">*</abbr> First name</label>
  <input type="text" name="embed_widget_form[first_name]" id="embed_widget_form_first_name" placeholder="Jane" />
</div>
<div>
  <label for="embed_widget_form_last_name">Last name</label>
  <input type="text" name="embed_widget_form[last_name]" id="embed_widget_form_last_name" placeholder="Smith" />
</div>
<div>
  <label for="embed_widget_form_email">Email</label>
  <input type="email" name="embed_widget_form[email]" id="embed_widget_form_email" placeholder="jane.smith@example.com" />
</div>
<div>
  <label for="embed_widget_form_phone">Phone</label>
  <input type="tel" name="embed_widget_form[phone]" id="embed_widget_form_phone" placeholder="555-555-5555" />
</div>
<div>
  <label for="embed_widget_form_role">Role</label>
  <input type="text" name="embed_widget_form[role]" id="embed_widget_form_role" placeholder="Bride" />
</div>
<div>
  <label for="embed_widget_form_all_day_date">Date</label>
  <input type="text" name="embed_widget_form[all_day_date]" id="embed_widget_form_all_day_date" placeholder="2/20/2017" />
</div>
<div>
  <label for="embed_widget_form_location">Venue Name</label>
  <input type="text" name="embed_widget_form[location]" id="embed_widget_form_location" placeholder="Hyatt Regency San Francisco" />
</div>
<div>
  <label for="embed_widget_form_street1">Venue Address</label>
  <input type="text" name="embed_widget_form[street1]" id="embed_widget_form_street1" placeholder="1 Embarcadero Center" />
</div>
<div>
  <label for="embed_widget_form_city">Venue City</label>
  <input type="text" name="embed_widget_form[city]" id="embed_widget_form_city" placeholder="San Francisco" />
</div>
<div>
  <label for="embed_widget_form_state">Venue State/Province</label>
  <input type="text" name="embed_widget_form[state]" id="embed_widget_form_state" placeholder="California" />
</div>
<div>
  <label for="embed_widget_form_zip">Venue Postal Code</label>
  <input type="text" name="embed_widget_form[zip]" id="embed_widget_form_zip" placeholder="94105" />
</div>
<div>
  <label for="embed_widget_form_referral_source">Where'd you hear about us?</label>
  <input type="text" name="embed_widget_form[referral_source]" id="embed_widget_form_referral_source" placeholder="Google" />
</div>
<div>
  <input type="hidden" name="embed_widget_form[time_zone]" id="embed_widget_form_time_zone" value="${this.props.viewer.s_time_zone}" />
</div>
<div>
  <label for="embed_widget_form_notes">Comments</label>
  <textarea name="embed_widget_form[notes]" id="embed_widget_form_notes" placeholder="Event will be outdoors. 200+ guests attending."></textarea>
</div>
${this.props.viewer.s_recaptcha_enabled ?
  `<div>
  <script src="https://www.google.com/recaptcha/api.js" async defer></script>
  <div class="g-recaptcha" data-sitekey="${this.props.viewer.s_recaptcha_site_key}"></div>
</div>` : ''}
<div style="position: absolute; left: -5000px;" aria-hidden="true">
  <input type="text" name="embed_widget_form[honey]" tabindex="-1" value="" />
</div>
<input type="submit" name="commit" value="Submit" data-disable-with="Submit" />
</form>
<script>
function get_zone(){var a,b;if("undefined"!=typeof Intl&&"undefined"!=typeof Intl.DateTimeFormat&&(a=Intl.DateTimeFormat(),"undefined"!=typeof a&&"undefined"!=typeof a.resolvedOptions))return b=a.resolvedOptions().timeZone,b&&(b.indexOf("/")>-1||"UTC"===b)?b:void 0}
document.getElementById("embed_widget_form_time_zone").value = get_zone();
</script>`;
  }

  selectEmbedCode() {
    if (document.selection) {
      const range = document.body.createTextRange();
      range.moveToElementText(document.getElementById('embedCode'));
      range.select();
    } else if (window.getSelection) {
      const range = document.createRange();
      range.selectNode(document.getElementById('embedCode'));
      window.getSelection().addRange(range);
    }
  }

  textFieldChange(e) {
    const newValue = {};
    newValue[e.target.name] = e.target.value;
    this.setState(Object.assign(this.state, newValue));
  }

  render() {
    const { relay, router, sidebarOpen, toggleSidebar, viewer } = this.props;
    const { activeIndex } = this.state;
    return (
      <Container>
        <Segment style={{ marginTop: '2em' }}>
          <MobileHeader
            viewer={viewer}
            router={router}
          >
            <div className='menu'>
              <Item
                as='a'
                className={sidebarOpen ? 'active ' : ''}
                onClick={toggleSidebar}
              >
                <Icon name='sidebar' />
              </Item>
            </div>
            <div className='right menu'>
              <AvailabilityChecker viewer={viewer} mobile />
              <Item as='a' onClick={router.push.bind(null, '/search')}>
                <Icon name='search' />
              </Item>
            </div>
          </MobileHeader>
          <Grid padded stackable>
            <Grid.Row columns='equal'>
              <Grid.Column>
                <h1>Custom Website Embed</h1>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={16}>
                <Accordion styled fluid>
                  <Accordion.Title
                    index={0}
                    active={activeIndex === 0}
                    onClick={this.onAccordionClick}
                  >
                    <Icon name='dropdown' />
                    Settings
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 0}>
                    <Grid padded relaxed stackable>
                      <Grid.Row>
                        <Grid.Column
                          width={5}
                          className={styles.settingsLabels}
                        >
                          <p>
                            <strong>Redirect URL</strong>
                          </p>
                          <p className={styles.helperText}>
                            <em>
                              When users submit your form, we will automatically
                              redirect them to the URL provided
                            </em>
                          </p>
                        </Grid.Column>
                        <Grid.Column width={11}>
                          <Formsy.Form className='ui form'>
                            <Input
                              label='Redirect URL'
                              type='text'
                              name='redirectURI'
                              value={this.state.redirectURI}
                              onChange={this.textFieldChange}
                              validations='isUrl'
                              validationError='Must be a valid URL (Ex. http://www.example.com)'
                            />
                          </Formsy.Form>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column
                          width={5}
                          className={styles.settingsLabels}
                        >
                          <p>
                            <strong>SMS Notifications</strong>
                          </p>
                          <p className={styles.helperText}>
                            <em>
                              Receive an SMS text message immediately after a
                              user submits an inquiry through your form.
                            </em>
                          </p>
                        </Grid.Column>
                        <Grid.Column width={11}>
                          <SMSNotifications
                            viewer={viewer}
                            relay={relay}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Accordion.Content>
                  <Accordion.Title
                    index={1}
                    active={activeIndex === 1}
                    onClick={this.onAccordionClick}
                  >
                    <Icon name='dropdown' />
                    reCAPTCHA Spam Protection
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 1}>
                    <RecaptchaSettings
                      viewer={viewer}
                      relay={relay}
                    />
                  </Accordion.Content>
                  <Accordion.Title
                    index={2}
                    active={activeIndex === 2}
                    onClick={this.onAccordionClick}
                  >
                    <Icon name='dropdown' />
                    Website Embed Code
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 2}>
                    <Grid padded relaxed stackable>
                      <Grid.Row>
                        <Grid.Column width={16}>
                          <p>
                            <strong>
                              Copy and paste the embed code wherever you want
                              the contact form to appear on your website.
                            </strong>
                          </p>
                          <br />
                          <ClipboardButton
                            option-text={this.getEmbedCode}
                            onSuccess={this.onSuccessfulCopy}
                            className='ui right icon button primary button'
                          >
                            <span>
                              Copy Embed Code&nbsp;<Icon name='copy outline' />
                            </span>
                          </ClipboardButton>
                          <Message warning style={{ marginTop: '3em' }}>
                            <Message.Header>
                              <Icon name='exclamation triangle' />
                              Unstyled Content
                            </Message.Header>
                            <p>
                              This code contains no styling. You can add your
                              own CSS or inherit from the default styles on your
                              website.
                            </p>
                          </Message>
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        <Grid.Column width={16}>
                          <pre
                            style={{
                              maxHeight: '400px',
                              whiteSpace: 'pre-line',
                              overflowY: 'scroll'
                            }}
                            onClick={this.selectEmbedCode}
                            id='embedCode'
                          >
                            {this.getEmbedCode()}
                          </pre>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Accordion.Content>
                  <Accordion.Title
                    index={3}
                    active={activeIndex === 3}
                    onClick={this.onAccordionClick}
                  >
                    <Icon name='dropdown' />
                    Preview Form
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === 3}>
                    <Grid padded stackable>
                      <Grid.Row columns='equal'>
                        <Grid.Column>
                          <p>
                            <strong>
                              Here is a preview of the form fields that you are
                              copying to your website:
                            </strong>
                          </p>
                          <br />
                          <Script url='https://www.google.com/recaptcha/api.js' />
                          <div
                            className='ui form'
                            dangerouslySetInnerHTML={{
                              __html: this.getEmbedCode()
                            }}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Accordion.Content>
                </Accordion>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    );
  }
};

export default withRouter(withAuth(EmbedComponent));



// WEBPACK FOOTER //
// ./webpack/components/Leads/EmbedComponent.js